import React from 'react';

const LCVProgressTracker = ({data, phase}) => {
  if (!data) return null;

  const {terms, activeTermIndex, activeSubPhase, introComplete, masteryReached, windowStart} = data;
  const windowEnd = Math.min(windowStart + 2, terms.length);
  const visibleTerms = terms.slice(windowStart, windowEnd);

  const isIntroActive = phase === 'frontloading';
  const isMasteryActive = ['mastery', 'results'].includes(phase);

  return (
    <div className="lcv-progress-bar">
      <div className={`lcv-pt-node ${isIntroActive ? 'lcv-pt-node-active' : introComplete ? 'lcv-pt-node-done' : ''}`}>
        <div className="lcv-pt-node-header">
          <span className="lcv-pt-num">{introComplete ? '✓' : '📋'}</span>
          <span className="lcv-pt-name">Intro</span>
        </div>
      </div>

      <div className="lcv-pt-connector" />

      {visibleTerms.map((t, i) => {
        const globalIdx = windowStart + i;
        const isActive = globalIdx === activeTermIndex && !isMasteryActive && !isIntroActive;
        const isDone = globalIdx < activeTermIndex;

        return (
          <React.Fragment key={globalIdx}>
            <div className={`lcv-pt-node ${isActive ? 'lcv-pt-node-active' : isDone ? 'lcv-pt-node-done' : ''}`}>
              <div className="lcv-pt-node-header">
                <span className="lcv-pt-num">{isDone ? '✓' : globalIdx + 1}</span>
                <span className="lcv-pt-name">{t.term}</span>
              </div>
              {isActive && activeSubPhase && (
                <div className="lcv-pt-steps">
                  <span className={`lcv-pt-step ${activeSubPhase === 'learning' ? 'lcv-pt-step-active' : ''}`}>📖 Learn</span>
                  <span className={`lcv-pt-step ${activeSubPhase === 'workbook' ? 'lcv-pt-step-active' : ''}`}>✏️ Work</span>
                  <span className={`lcv-pt-step ${activeSubPhase === 'knowledge_check' ? 'lcv-pt-step-active' : ''}`}>✅ Check</span>
                </div>
              )}
            </div>
            {i < visibleTerms.length - 1 && <div className="lcv-pt-connector" />}
          </React.Fragment>
        );
      })}

      <div className="lcv-pt-connector" />

      <div className={`lcv-pt-node ${isMasteryActive ? 'lcv-pt-node-active' : masteryReached ? 'lcv-pt-node-done' : ''}`}>
        <div className="lcv-pt-node-header">
          <span className="lcv-pt-num">{masteryReached ? '✓' : '🏆'}</span>
          <span className="lcv-pt-name">Mastery</span>
        </div>
      </div>
    </div>
  );
};

export default LCVProgressTracker;
